var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Card } from '@aptive-env/storybook';
import SatelliteImage from 'assets/image/satellite.png';
import TerrainImage from 'assets/image/terrain.png';
import TrafficImage from 'assets/image/traffic.png';
import ImageLayers from 'assets/image/layers.png';
import { EMapType } from 'interface/map';
export var MapTypeChangeButton = function (_a) {
    var type = _a.type, onClick = _a.onClick;
    var image = useMemo(function () {
        if (type === EMapType.SATELLITE) {
            return SatelliteImage;
        }
        if (type === EMapType.TERRAIN) {
            return TerrainImage;
        }
        if (type === EMapType.TRAFFIC) {
            return TrafficImage;
        }
        return TrafficImage;
    }, [type]);
    return (_jsx(Card, __assign({ className: "h-[80px] w-[80px] bg-ui-snow rounded-lg shadow-med p-[2px] cursor-pointer overflow-hidden relative", onClick: onClick }, { children: _jsxs("div", __assign({ className: "h-full rounded-lg flex flex-col items-center justify-center", style: { background: 'linear-gradient(180deg, rgba(217, 217, 217, 0.00) 0%, rgba(4, 4, 4, 0.80) 100%)' } }, { children: [_jsx("div", __assign({ className: "absolute overflow-hidden p-[2px]" }, { children: _jsx("img", { src: image, alt: "Map", className: "rounded-[6px] w-full" }) })), _jsxs("div", __assign({ className: "flex items-center absolute left-[8px] bottom-[8px]" }, { children: [_jsx("img", { src: ImageLayers, alt: "ImageLayers" }), _jsx("span", __assign({ className: "ml-1 font-bold text-white text-xs", style: { textShadow: '0px 1px 0px rgba(0, 0, 0, 0.80)' } }, { children: "Map" }))] }))] })) })));
};
